import dayjs from 'dayjs';

export function formatCurrency(val: number): string {
  if (val >= 1_000_000) return `${(val / 1_000_000).toFixed(1)}M`;
  if (val >= 1_000) return `${(val / 1_000).toFixed(0)}K`;
  return val.toFixed(0);
}

/** Date and time for audit fields (Created At, Last Modified, etc.). */
export function formatAuditDateTime(value: string | null | undefined): string {
  if (value == null || value === '') return '—';
  const parsed = dayjs(value);
  if (!parsed.isValid()) return value;
  return parsed.format('MMM D, YYYY · h:mm A');
}

export function formatAuditUserName(
  displayName: string | null | undefined,
  userId: string | null | undefined,
): string {
  if (displayName != null && displayName !== '') return displayName;
  if (userId != null && userId !== '') return userId;
  return '—';
}
